<template>
  <div v-if="specialBets">
    <li v-for="specialBet in specialBets"
        :key="specialBet.id"
        class="list-group-item text-primary"
        :class="{'font-weight-bolder': !specialBet.finished}"
        @click="$emit('selected', specialBet)">
      <div class="small text-dark">{{ specialBet.start | calendar }}</div>
      {{ specialBet.description }}
    </li>
  </div>
</template>

<script>
export default {
  props: {
    specialBets: Array,
  }
}
</script>
